var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60624 0.860055C6.98303 0.874775 7.35323 0.963641 7.69565 1.12157C8.03806 1.2795 8.34598 1.50339 8.60178 1.78043C8.85759 2.05748 9.05626 2.38224 9.18643 2.73614C9.31661 3.09004 9.37572 3.46613 9.3604 3.8429V10.8625C9.38461 11.6193 9.10867 12.3549 8.59275 12.909C8.07682 13.4631 7.36276 13.7907 6.60624 13.8205C5.84884 13.792 5.13351 13.4649 4.61653 12.9107C4.09954 12.3564 3.82292 11.6201 3.84711 10.8625V3.82302C3.8318 3.44585 3.89108 3.06936 4.02156 2.71515C4.15204 2.36093 4.35115 2.03595 4.60748 1.75884C4.86381 1.48173 5.17231 1.25794 5.5153 1.10029C5.85829 0.942649 6.22902 0.854252 6.60624 0.840169V0.860055ZM6.60624 0C6.11808 0.0128505 5.63729 0.122108 5.19152 0.321486C4.74575 0.520864 4.34381 0.806426 4.00883 1.16174C3.67385 1.51705 3.41243 1.9351 3.23963 2.39183C3.06684 2.84856 2.98606 3.33495 3.00196 3.82302V10.8625C2.97655 11.8437 3.34112 12.795 4.01578 13.5078C4.69044 14.2207 5.62018 14.6371 6.60127 14.6657C7.58236 14.6371 8.5121 14.2207 9.18676 13.5078C9.86142 12.795 10.226 11.8437 10.2006 10.8625V3.82302C10.226 2.84184 9.86142 1.8906 9.18676 1.17773C8.5121 0.464861 7.58236 0.0485017 6.60127 0.0198856",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79688 20H10.1397",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46875 16.6953V19.9367",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.3228V11.0016C1.01178 12.3943 1.54878 13.7312 2.50366 14.7451C3.45853 15.759 4.76091 16.3751 6.15039 16.4702H6.9657C8.33626 16.3564 9.61364 15.7304 10.5433 14.717C11.4729 13.7035 11.9866 12.3769 11.9819 11.0016V7.29297",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoice);
export default __webpack_public_path__ + "static/media/voice.493fb734a53ff6f9a9644d1dbbc580bd.svg";
export { ForwardRef as ReactComponent };